'use strict';

/**
 * @name CheckoutController - Checkout controller handles reservation and payments.
 */
function CheckoutController($state, HoogyService, UIService, CheckoutService, NotificationService, StateService, ActionCreator, Angularytics) {
    
    var vm = this;
    
    /**
     * @param {Object} Order - order being edited, a minimal form 
     * @param {Object} Item - item being rented out 
     * @param {Object} Contract - contract Object. 
     * @param {Object} Payment - Order.Payment object. 
     * @param {Object} Card - card, if customer object is not available or customer willing to change a card.  
     * @param {Object} Customer - customer Object or CustomerID string 
     */
    this.$onInit = function () {
        this.model = CheckoutService.getModel(); //model related to data being used 
        this.unsubscribe = this.subscribe();
        var id = this.model.item._id || this.model.item.id || $state.params.id;
        var url = [AppConfig.Config.server, '/item/', id].join('');
        var settings = {
            url: url,
            gravatar: HoogyService.gravatar,
            component: 'checkout',
            action : 'index',
            active: 'index'
        };
        
        this.screen = UIService.getCheckoutScreen(settings);
        StateService.dispatch(ActionCreator.addScreen(this.screen));
        StateService.dispatch(ActionCreator.showHideRootLoading({value: false}));        
        StateService.dispatch(ActionCreator.showHideSidebar({value: false}));  
        this.init();
    };

    this.subscribe = function () {
        return typeof this.unsubscribe === 'function' ? false: StateService.subscribe(function () {
            vm.model = CheckoutService.getModel();
            vm.screen = UIService.getCheckoutScreen(vm.screen);
            vm.screen.notifications = NotificationService.getModel(); 
            //@todo --- Direct Notification For Current Screen
            //vm.screen.notification = NotificationService.getCheckoutScreen();
        });
    };
    /**
     * @name $onDestroy - cleans objects when components dies.
     */
    this.$onDestroy = function () {
        if (typeof this.unsubscribe === 'function') {
            this.unsubscribe();
            this.unsubscribe = null;
        }
    };

    /**@link https://scotch.io/tutorials/angularjs-multi-step-form-using-ui-router**/
    this.init = function () {
        this.omnibox = false; //shows the omnibox
        this.notification = {};
        Angularytics.trackEvent('Checkout Initialized', +1);
    };

    /**
     * @deprecated - initialization of a form will be next at form levels
     * Hack to initialize form on compile time.
     * Normally forms are initialized first time it is used. 
     */
    this.initForm = function (form) {
        this.item = form;
    };
    /**
     * @name _handleException - handles exceptions when server sends error code.
     * @param {Object} response - object passed along from request promise 
     */
    this._handleException = function (error) {
        vm.screen.waiting = false;
        var notice = NotificationService.formatCheckoutFailureMessage(error);
        NotificationService.report(notice);
        Angularytics.trackEvent('Checkout - Exception', notice.message);
        return error;
    };

    this.close = function () {
        $state.go('workspace.discover');
    };



}
CheckoutController.$inject = ['$state', 'HoogyService', 'UIService', 'CheckoutService', 'NotificationService', 'StateService', 'ActionCreator', 'Angularytics'];
angular.module('hoogy').component('checkout', {
    controllerAs: 'vm',
    controller: CheckoutController,
    templateUrl: 'js/checkout/view/index.html'
});

/**
 * Component used to edit Checkout(start payment) form. 
 * @name StartCheckoutController - Starting a pyment procedure. 
 */
function StartCheckoutController(CheckoutService, StateService) {
    var vm = this;

    this.$onInit = function () {
        this.model = CheckoutService.getModel();
        this.unsubscribe = this.subscribe();
    };

    this.subscribe = function () {
        return typeof this.unsubscribe === 'function' ? false: StateService.subscribe(function () {
            vm.model = CheckoutService.getModel();
        });
    };

    /**
     * @name $onDestroy - cleans objects when components dies.
     */
    this.$onDestroy = function () {
        if (typeof this.unsubscribe === 'function') {
            this.unsubscribe();
        }
        this.unsubscribe = null;
    };
}
StartCheckoutController.$inject = ['CheckoutService', 'StateService'];
angular.module('hoogy').component('hgCheckout', {
    controllerAs: 'vm',
    controller: StartCheckoutController,
    templateUrl: 'js/checkout/view/hg-checkout.html'
});
/**
 * @todo -- reusing a credit card while paying
 * @name ReuseController - function to reuse a credit card. 
 */
function ReuseController(CheckoutService, StateService) {
    var vm = this;

    this.$onInit = function () {
        this.model = CheckoutService.getModel();
        this.unsubscribe = this.subscribe();
    };

    this.subscribe = function () {
        return typeof this.unsubscribe === 'function' ? false: StateService.subscribe(function () {
            vm.model = CheckoutService.getModel();
        });
    };
    /**
     * @name $onDestroy - cleans objects when components dies.
     */
    this.$onDestroy = function () {
        if (typeof this.unsubscribe === 'function') {
            this.unsubscribe();
        }
        this.unsubscribe = null;
    };
}
ReuseController.$inject = ['CheckoutService', 'StateService'];
angular.module('hoogy').component('hgReuse', {
    controllerAs: 'vm',
    require: {
        checkout: '^checkout'
    },
    controller: ReuseController,
    templateUrl: 'js/checkout/view/hg-reuse.html'
});

/**
 * @todo separate a couple more items. 
 * Checkout form - is more of Credit Card payment. 
 * @name FCheckoutController - Credit Card Payment Form
 */
function FCheckoutController(CheckoutService, StateService) {
    var vm = this;
    
    this.$onInit = function () {
        this.model = CheckoutService.getModel();
        this.unsubscribe = this.subscribe();
    };

    this.subscribe = function () {
        return typeof this.unsubscribe === 'function' ? false: StateService.subscribe(function () {
            vm.model = CheckoutService.getModel();
        });
    };
    /**
     * @name $onDestroy - cleans objects when components dies.
     */
    this.$onDestroy = function () {
        if (typeof this.unsubscribe === 'function') {
            this.unsubscribe();
        }
        this.unsubscribe = null;
    };
}
FCheckoutController.$inject = ['CheckoutService', 'StateService'];
angular.module('hoogy').component('hgFcheckout', {
    controllerAs: 'vm',
    controller: FCheckoutController,
    templateUrl: 'js/checkout/view/hg-fcheckout.html'
});